import React, { useState, useContext, useEffect } from 'react';
import { formatPrice } from '../../js/components/shared/vehicleFunctions';
import { VehiclesContext } from '../../contexts/VehiclesContext';
import Traductor from '../../components/Traductor';
import { disableHTMLOverflow } from '../../Functions';

import userWelcomeSVG from '../../images/icons/user-credit-card.svg';
import '../../css/components/shared/ModalFirstBidPreferences.css';
import Globals from '../../Globals';

function ModalDirectPurchase({ history, options, closeModal }) {
    const t = new Traductor();
    const { setSelectedVehicle } = useContext(VehiclesContext);
    const [ariaHidden, setAriaHidden] = useState('false');

    const onClickGoToDirectPurchase = () => {
        setSelectedVehicle(options.vehicle);
        disableHTMLOverflow(false);
        history.push(Globals.APPLICATION_PATH.DIRECT_PURCHASE);
    };

    const closeThisModal = () => {
        closeModal('');
        setAriaHidden('true');
    };

    return (
        <div
            className="c-modal c-modal--first-bid-preferences"
            aria-hidden={ariaHidden}
            id="demo-modal"
        >
            <div
                className="c-modal__overlay  js-modal-close"
                tabIndex="-1"
            ></div>
            <div className="c-modal__wrapper" role="dialog">
                <header className="c-modal__header">
                    <button
                        className="c-modal__close-btn  js-modal-close"
                        type="button"
                        aria-label="Cerrar modal."
                        onClick={closeThisModal}
                    ></button>
                    <div className="c-modal__title__wrapper">
                        <img src={userWelcomeSVG} alt="Welcome"></img>
                        <h1 className="c-modal__title">
                            {options.bid == options.vehicle.Price
                                ? t.getTraduction(
                                      'ModalDirectPurchase_Title_equal'
                                  )
                                : t.getTraduction(
                                      'ModalDirectPurchase_Title_surpass'
                                  )}
                        </h1>
                    </div>
                </header>
                <div className="c-modal__content" role="document">
                    <p>
                        {t.getTraduction('ModalDirectPurchase_Body')}
                        <strong>
                            {' ' +
                                t.getTraduction('ModalDirectPurchase_Body_2') +
                                ' ' +
                                formatPrice(options.vehicle.Price) +
                                '.'}
                        </strong>
                        {' ' + t.getTraduction('ModalDirectPurchase_Body_3')}
                    </p>
                </div>
                <div className="c-modal__footer">
                    <div className="c-modal__actions">
                        <div className="c-modal__actions__item">
                            <button
                                className="c-btn c-btn--secondary js-modal-close"
                                aria-label="No quiero comprarlo directamente."
                                onClick={closeThisModal}
                            >
                                <span className="c-btn__text">
                                    {t.getTraduction('Cancelar')}
                                </span>
                            </button>
                        </div>
                        <div className="c-modal__actions__item">
                            <button
                                className="c-btn js-modal-close js-modal-autofocus"
                                aria-label="Comprar directamente."
                                onClick={onClickGoToDirectPurchase}
                            >
                                <span className="c-btn__text">
                                    {t.getTraduction('BuyNow')}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalDirectPurchase;
